import { State } from 'moduleBase/types/State';
import { ActionCreatorsMapObject, bindActionCreators } from 'redux';
import React, { FC, useEffect } from 'react';
import SvgSprite from 'components/html-elements/SvgSprite';
import { When } from 'react-if';
import realtimeNotification from 'srcJs/components/realtime-notification/realtime-notification';
import {
  MESSAGE_TYPE_MESSENGER,
  MESSAGE_TYPE_MESSENGER_READ,
} from 'srcJs/components/realtime-notification/constants/constants';
import { connect } from '@collaborator/npm_modules/dist/components/redux';
import { Link } from 'components/router/Link';
import { NotifierStateType } from 'moduleChatNotifier/types/NotifierStateType';
import { REDUCER_CHAT_NOTIFIER_NAME } from 'moduleChatNotifier/constants';
import { reducerChatNotifier } from 'moduleChatNotifier/reducers';
import { chatNotifierLoad } from 'moduleChatNotifier/actions/load';

type DispatchPropsType = {
  load: () => void;
}

type PropsType = NotifierStateType & DispatchPropsType;

const Notifier: FC<PropsType> = ({
  load,
  countNotViewed,
}) => {
  const loadData = () => {
    load();
  };

  const handlerNewMessage = () => {
    loadData();
  };

  const handlerRead = () => {
    loadData();
  };

  useEffect(() => {
    loadData();

    realtimeNotification.addListener(MESSAGE_TYPE_MESSENGER, handlerNewMessage);
    realtimeNotification.addListener(MESSAGE_TYPE_MESSENGER_READ, handlerRead);

    return () => {
      realtimeNotification.removeListener(handlerNewMessage);
      realtimeNotification.removeListener(handlerRead);
    };
  }, []);

  return (
    <Link to="/chat" className="text-decoration-none text-reset d-flex align-items-center">
      <SvgSprite id="messages" size={16} />
      <When condition={countNotViewed}>
        <span className="font-weight-bold ml-4p lh-narrow">
          {countNotViewed}
        </span>
      </When>
    </Link>
  );
};

export default connect<NotifierStateType, DispatchPropsType>(Notifier, {
  reducers: { name: REDUCER_CHAT_NOTIFIER_NAME, reducer: reducerChatNotifier },
  mapStateToProps: (state: State) => state[REDUCER_CHAT_NOTIFIER_NAME],
  mapDispatchToProps: (dispatch) => (bindActionCreators<ActionCreatorsMapObject, DispatchPropsType>({
    load: chatNotifierLoad,
  }, dispatch)),
});
